export enum IdeaPermissionAction {
  CREATE_BOARD = 'create_board',
  ADD_COMMENT = 'add_comment',
  READ = 'read',
  UPDATE = 'update',
  DELETE = 'delete',
  DISCOVER = 'discover'
}